import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';
import Popup from '../../Popup';
import s from '../Popup.css';
import Messages from '../Messages';
import cx from 'classnames';
import Button from '../../Button';
import Loader from '../../Loader';
import Icon from '../../Icon';
import { optionsParser, safeFloorParser } from '../../../core/utils';
import PairingBox from './PairingBox';
import {
  getLiveDeviceData,
  clearDeviceUserData,
  getDeviceInfo,
  setDeviceCommandValue,
} from '../../../actions/device';
import { getSafeFloorList } from '../../../actions/home';
import { getActiveNoConnectedFloorSensors } from './utils';
import { isPriviliged } from '../../../core/deviceHelper';
import { saveInstallationData } from '../../../actions/device';

import CommonDevice from '../../CommonDevice';
import ConnectedDevicesSafeTechXSafeFloor from './ConnectedDevicesSafeTechXSafeFloor';



class SafeFloorInstallation extends CommonDevice {
  constructor(props) {
    super(props);
    this.state = {
      pairingStarted: false,
      allowToSaveInstallation: false,
      pairingStatus: null,
      counter: 0,
      confirm: false,
      safefloorSerialToPair: null,
    };
  }

  componentWillMount() {
    const deviceName = 'safetech';

    this.props.clearDeviceUserData(deviceName);
    this.props.getDeviceInfo(this.props.serial, deviceName);
    this.props.getLiveDeviceData(this.props.serial, deviceName);

    this.props.getSafeFloorList ({
      filterconnect: 'online',
      filterdevicetype: 'safefloor',
    })
  }


  confirmClicked = () => {
    this.setState({
      confirm: true,
    });
  }

  saveInstallation = () => {
    this.props.saveInstallationData({
      serial: this.props.serial,
      safetech_serial: this.props.serial,
      safefloor_serial: this.state.safefloorSerialToPair,
    });
    this.props.getDeviceInfo(this.props.serial, 'safetech');
  }

  saveInstallationClick = () => {
    this.saveInstallation();
    this.setState({
      allowToSaveInstallation: false,
    });
  }

  cancelSaveInstallationClick = () => {
    this.setState({
      allowToSaveInstallation: false,
    });
  }


  checkForNewData = () => {
    const { device, serial } = this.props;
    if (device.get('liveRequestInProgress') === false) {
      this.checkStatus()
      this.props.getLiveDeviceData(serial, 'safetech');
    }
  };


  checkStatus = () => {
    // we want to check only 60 seconds
    const { intl, device } = this.props;
    const messages = Messages();

    if (this.state.counter && this.state.pairingStarted ) {
      // check status 
      const liveData = device.get('live');
      const pairingStatusFromDevice = liveData[`getFSA${this.state.safefloorSerialToPair}`];
      let pairingStatus = null;
      let pairingStarted = true;
      let allowToSaveInstallation = false;
      if (pairingStatusFromDevice != undefined){
        switch(+pairingStatusFromDevice){
          case 0:
            pairingStatus = null;
            pairingStarted = false;
            allowToSaveInstallation = true;            
            break;
          case 1:
            pairingStatus = intl.formatMessage(messages.pairing_status_active);
            break;
          case 2:
            pairingStatus = null;
            pairingStarted = false;
            this.saveInstallation();
           break;
          default:
            break;
        }
        this.setState({
          pairingStarted,
          pairingStatus,
          allowToSaveInstallation,
        });
      }
      
      this.setState({
        counter: this.state.counter - 1
      });
    } else {
        // clear before next
        if(this.state.safefloorSerialToPair === null){
          this.setState({
            pairingStarted: false,
            safefloorSerialToPair: null,
            pairingStatus: null,
          });          
        }
    }

  };


  onClick = () => {
    // check if safefloor is active
    this.props.getLiveDeviceData(this.state.safefloorSerialToPair, 'safefloor');
    const liveData = this.props.safefloor.get('live');

    this.props.setDeviceCommandValue(this.props.serial, "setFSA", this.state.safefloorSerialToPair);

    this.setState({
      counter: 60,
      pairingStarted: true,
    });
  };

  onValueChange = (value) => {
    this.setState({
      safefloorSerialToPair: value,
    });
  }


  render() {
    const { device, devicePaging, authentication, serial, intl } = this.props;
    const userRole = authentication.get('userRole');
    const messages = Messages();

    return (
      <Popup
        className={s.Popup__editdevice}
        onClose={this.props.onClose}
        overrideOnClose
      >
        <div className={s.wrapper}>
          <div className={s.first}>
            <ConnectedDevicesSafeTechXSafeFloor 
              device={device}
              userRole={userRole}
              serial={serial}
            />
          </div>
          <div className={s.second}>
          {this.state.confirm ? (
            <PairingBox
              device={device}
              devicePaging={devicePaging}
              pairingStarted={this.state.pairingStarted}
              pairingStatus={this.state.pairingStatus}
              onSelectChanged={this.onValueChange}
              allowToSaveInstallation={this.state.allowToSaveInstallation}
              saveInstallationClick={this.saveInstallationClick}
              cancelSaveInstallationClick={this.cancelSaveInstallationClick}
              onClick={this.onClick}
             />          
            ) : (
            <div>
              <span dangerouslySetInnerHTML={
                { __html: intl.formatMessage(
                    messages.pairing_cofirmation_info_text,
                  )}}>
              </span>
              <br/>
              <div className={s.buttonHolder}>
                <Button          
                  buttonColor="light"
                  onClick={this.confirmClicked}
                >
                  <div className={s.white_text}>
                    <FormattedMessage {...messages.pairing_confirmation_text} />
                  </div>
                </Button>
              </div>
            </div>

          )}
          </div>
        </div>
      </Popup>
    );
  }
}

SafeFloorInstallation.propTypes = {
  onClose: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
  serial: PropTypes.string.isRequired,
  devicetype: PropTypes.string,
  getLiveDeviceData: PropTypes.func.isRequired,
  getDeviceInfo: PropTypes.func.isRequired,
  getSafeFloorList: PropTypes.func.isRequired,
  clearDeviceUserData: PropTypes.func.isRequired,
  device: PropTypes.object.isRequired,
  safefloor: PropTypes.object.isRequired,
  devicePaging: PropTypes.object.isRequired,
  authentication: PropTypes.object.isRequired

};

SafeFloorInstallation.defaultProps = {
  devicetype: '',
};


const mapState = state => ({
  device: state.safetechReducer,
  safefloor: state.safefloorReducer,
  devicePaging: state.devicePaging,
  user: state.user,
  authentication: state.authentication,
});


const mapDispatch = dispatch => {
  return {
    getDeviceInfo: (deviceId, deviceType) =>
      dispatch(getDeviceInfo(deviceId, deviceType)),
    getLiveDeviceData: (deviceId, deviceType) =>
      dispatch(getLiveDeviceData(deviceId, deviceType)),
    clearDeviceUserData: devicetype =>
      dispatch(clearDeviceUserData(devicetype)),
    getSafeFloorList: params => dispatch(getSafeFloorList(params)),
    setDeviceCommandValue: (deviceId, command, value) => 
      dispatch(setDeviceCommandValue(deviceId, command, value)),
    saveInstallationData: (data) => dispatch(saveInstallationData(data)),
  };
};

export default injectIntl(
  compose(connect(mapState, mapDispatch), withStyles(s))
  (SafeFloorInstallation)
);



// WEBPACK FOOTER //
// ./src/components/Popup/DevicePopups/SafeFloorInstallation.js